import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";

import {
    COST_TRACKERS_LIST, GET_COST_TRACKERS_LIST, SEARCH_COST_TRACKER_BY_ID, COST_TRACKER_BY_ID,
    GET_CLOUD_PROVIDERS_LIST, CLOUD_PROVIDERS_LIST, DELETE_EVENT, DELETE_EVENT_RESP, SAVE_COST_TRACKER,
    SAVE_COST_TRACKER_RESP, DELETE_COST_TRACKER, DELETE_COST_TRACKER_RESP, GET_ALL_EVENTS_RESP, GET_ALL_EVENTS,
    GET_EVENT_INFO, GET_EVENT_INFO_RESP, SAVE_EVENT, SAVE_EVENT_RESP, SEARCH_COST_TRACKER_BY_FIELD,
    GET_COST_TRACKER_CONTRACTS, SET_COST_TRACKER_CONTRACTS, COST_TRACKER_BY_FIELD_LIST
} from "./actionTypes";

export class GetCostTrackersList implements Action {
    readonly type = GET_COST_TRACKERS_LIST;
}

export class CostTrackersList implements Action {
    readonly type = COST_TRACKERS_LIST;
    readonly payload = []
    constructor(costTrackersList: Array<any>) {
        this.payload = costTrackersList;
    }
}

export class SearchCostTrackerById implements Action {
    readonly type = SEARCH_COST_TRACKER_BY_ID;
    readonly payload: string = null;
    constructor(id) {
        this.payload = id
    }
}

export class CostTrackerById implements Action {
    readonly type = COST_TRACKER_BY_ID;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class GetCloudProvidersList implements Action {
    readonly type = GET_CLOUD_PROVIDERS_LIST;
}

export class CloudProvidersList implements Action {
    readonly type = CLOUD_PROVIDERS_LIST;
    readonly payload = []
    constructor(cloudProvidersList: Array<any>) {
        this.payload = cloudProvidersList;
    }
}

export class SaveCostTracker implements Action {
    readonly type = SAVE_COST_TRACKER;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class SaveCostTrackerResp implements Action {
    readonly type = SAVE_COST_TRACKER_RESP;
    readonly payload = null;
    constructor(resp: IServerResponse) {
        this.payload = resp;
    }
}

export class DeleteCostTracker implements Action {
    readonly type = DELETE_COST_TRACKER;
    readonly payload: string = null;
    constructor(data) {
        this.payload = data;
    }
}

export class DeleteCostTrackerResp implements Action {
    readonly type = DELETE_COST_TRACKER_RESP;
    readonly payload = null;
    constructor(resp: IServerResponse) {
        this.payload = resp;
    }
}

export class GetEventsForTracker implements Action {
    readonly type = GET_ALL_EVENTS;
    readonly payload: string = null;
    constructor(data) {
        this.payload = data;
    }
}

export class GetEventsForTrackerResp implements Action {
    readonly type = GET_ALL_EVENTS_RESP;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class GetEventInfo implements Action {
    readonly type = GET_EVENT_INFO;
    readonly payload: string = null;
    constructor(data) {
        this.payload = data;
    }
}

export class EventInfoResp implements Action {
    readonly type = GET_EVENT_INFO_RESP;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class SaveEvent implements Action {
    readonly type = SAVE_EVENT;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class SaveEventResp implements Action {
    readonly type = SAVE_EVENT_RESP;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class DeleteEvent implements Action {
    readonly type = DELETE_EVENT;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class DeleteEventResp implements Action {
    readonly type = DELETE_EVENT_RESP;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class SearchCostTrackerByField implements Action {
    readonly type = SEARCH_COST_TRACKER_BY_FIELD;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class CostTrackerByFieldList implements Action {
    readonly type = COST_TRACKER_BY_FIELD_LIST;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class GetCostTrackerContracts implements Action {
    readonly type = GET_COST_TRACKER_CONTRACTS;
    readonly payload: string;
    constructor(organisationId: string) {
        this.payload = organisationId;
    }
}

export class SetCostTrackerContracts implements Action {
    readonly type = SET_COST_TRACKER_CONTRACTS;
    readonly payload: any;
    constructor(contracts: Array<any>) {
        this.payload = contracts;
    }
}

export type Actions = GetCostTrackersList | CostTrackersList | SearchCostTrackerById | CostTrackerById
    | GetCloudProvidersList | CloudProvidersList
    | GetEventsForTracker | GetEventsForTrackerResp
    | SaveEvent | SaveEventResp | DeleteEvent | DeleteEventResp | SaveCostTracker
    | SaveCostTrackerResp | DeleteCostTracker | DeleteCostTrackerResp | GetEventInfo | EventInfoResp |
    SearchCostTrackerByField | CostTrackerByFieldList | GetCostTrackerContracts | SetCostTrackerContracts;
